"use client";
import React, { useMemo } from 'react';
import { AbTestingSdk } from '@sravni/ab-testing-sdk/lib/browser';
import { DEFAULT_VALUE, AbTestingContext } from './Context.js';

function UncontrolledAbTestingProvider(props) {
    const { initialValue: params, children } = props;
    const sdk = useMemo(() => (params ? new AbTestingSdk(params) : DEFAULT_VALUE), [params]);
    const [currentSdk] = React.useState(sdk);
    return React.createElement(AbTestingContext.Provider, { value: currentSdk }, children);
}

export { UncontrolledAbTestingProvider };
//# sourceMappingURL=Uncontrolled.js.map
